import {Fragment, memo} from 'react'

import type {NormalizedBuild, ProjectOrBuildTypeNode} from '../../../types'
import {stringifyId} from '../../../types'

import BuildDetails from './BuildDetails/BuildDetails'

type BuildDetailsRenderProps = {
  alwaysShowLineBorders: boolean
  builds: ReadonlyArray<NormalizedBuild>
  wrapped: boolean
  pathFilter?: ProjectOrBuildTypeNode | null
  renderBuild?: (
    build: NormalizedBuild,
    prevBuildId?: number,
    nextBuildId?: number,
  ) => React.ReactNode
  build: NormalizedBuild
  index: number
}

function BuildDetailsRender({
  build,
  wrapped,
  alwaysShowLineBorders,
  pathFilter,
  builds,
  renderBuild,
  index,
}: BuildDetailsRenderProps) {
  if (renderBuild) {
    return <Fragment>{renderBuild(build, builds[index - 1]?.id, builds[index + 1]?.id)}</Fragment>
  }

  return (
    <BuildDetails
      key={stringifyId(build.id)}
      buildId={build.id}
      alwaysShowLineBorders={alwaysShowLineBorders || build.state === 'queued'}
      wrapped={wrapped}
      pathFilter={pathFilter}
    />
  )
}

export default memo(BuildDetailsRender)
